import Vue from 'vue'// Vue框架本体。
import App from './App.vue'// 整个应用根实列。
import router from './router'// 路由。
import Util from './utils/index' // 工具类。
import store from './store'
import axios from 'axios' // 网络请求。
import Qs from 'qs' // 参数序列化。
import vuex from 'vuex'

// 移动端适配
import 'lib-flexible'

// import './assets/rem.js' //  './assets/js/rem.js' ==>对应正确文件路劲
import { Toast } from 'vant'
// 引入全部样式
import 'vant/lib/index.less'
// 定制主题

// 引入公共样式
import './assets/global.less'

// 引入echarts
import echarts from 'echarts'
import animated from 'animate.css'

// 引入百度地图
import BaiduMap from 'vue-baidu-map'
// import api from './utils/ysImg.js'// 压缩图片
Vue.use(vuex)
Vue.use(Toast)
Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: 'rO5fvsFLjWX98MbfBARnQ3tGzdkRm1xi'
})

// 将echarts注册到Vue组件的原型对象中去
Vue.prototype.$echarts = echarts
Vue.use(animated)

// 挂载 util 到原型上， 使每一个vue文件都可以使用 this.util 来直接使用 工具类 ，避免重复 import。
Vue.prototype.util = Util
Vue.config.productionTip = false // 这里注意自己的路径
// Vue.prototype.$api = api // 注册为全局变量

// 初始化 axios 的参数转换，使请求直接传递 {} 这种参数可以转换为普通的表单格式请求。
axios.defaults.transformRequest = obj => {
  // 不能一味的对所有要提交的内容进行 Qs.stringify
  if (Object.prototype.toString.call(obj).indexOf('FormData') !== -1) {
    return obj
  }
  return Qs.stringify(obj)
}
if (process.env.NODE_ENV === 'production') {
  // 线上环境,由于线上环境的地址未知，所以此处不配置。不配置将使用和页面相同的host地址。
  axios.defaults.baseURL =window.config.baseUrl//'http://192.168.1.137:20002/api'//
} else {
  // 测试、本地 （线上环境以外的其它环境）
  axios.defaults.baseURL =window.config.baseUrl//'http://192.168.1.137:20002/api'//
}
axios.interceptors.response.use((response) => {
  const status = response.data.code
  let showcookie = localStorage.getItem('UserToken')
  if (status === '401') {
    if (window.config.type === 0) {
      router.push('/login')
    } else {
      router.push('/errorLoginPage')
    }
    if (showcookie === '' || showcookie == null) {
      window.parent.location.href = '/'
    } else {
      window.parent.location.href = '/'
    }
  } else if (status === '404') {
    router.push('/404')
  } else if (status === '101' || status === '102') {
    Toast(response.data.msg)
    setTimeout(() => {
      if (window.config.type === 0) {
        router.push('/login')
      } else {
        router.push('/errorLoginPage')
      }
    }, 2000)

    // 清除浏览器缓存
    localStorage.removeItem('UserToken')
  } else return response
}, error => Promise.reject(error))

window._axiosPromiseArr = [] // axios中设置放置要取消的对象
axios.interceptors.request.use(
  config => {
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel })
    })// --------------------------------------------------------切换路由菜单，终止上个页面的请求----------------------
    let showcookie = localStorage.getItem('UserToken')
    // alert(config.url)// 接口地址
    if ((showcookie === '' || showcookie == null) && config.url !== '/login' && config.url !== '/newlogin' && config.url !== '/updatePW' && config.url !== '/updatePWByVerificationCode' && config.url !== '/updatePWByQRVerificationCode' && config.url !== '/loginVerificationCode' && config.url !== '/loginRegister') {
      // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
      // config.headers['Authorization'] = showcookie
      // if(config.url.indexOf('login') < 0){}
      if (window.config.type === 0) {
        router.push('/login')
      } 
    } else {
      config.headers.UserToken = showcookie
    }

    return config
  },
  err => {
    // console.log(axios.isCancel(err))
    // if (axios.isCancel(err)) { // 取消请求的情况下，终端Promise调用链
    //   return new Promise(() => {})
    // } else {
    //   return Promise.resolve(err)
    // }
    // Message.error({ message: '请求超时!' })
    return Promise.resolve(err)
    // return Promise.reject(err) // 请求错误时，直接结束
    // return Promise.resolve(err);//请求错误时，不会直接结束，将会继续传到then里面,无论请求成功还是失败，在成功的回调中都能收到通知
  }
)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // alert(from.path + '---' + to.path)
  // console.log('from' + '---' + from.path)
  // console.log('next' + '---' + next.path)
  window._axiosPromiseArr.forEach((ele, index) => {
    ele.cancel() // 路由跳转之前，清空（终止）上一个页面正在请求的内容
    // 清空请求的参数 清空请求的参数
    delete window._axiosPromiseArr[index]
  })

  // 这里是在所有路由跳转之前都会去执行以下操作
  if (to.path === '/' || localStorage.getItem('UserToken') || to.path.indexOf('login') > 0 || to.path.indexOf('newlogin') > 0 || to.path === '/register' || to.path === '/forgetPSWPage' || to.path === '/guide' || from.path === '/guide') {
    next()
  } else {
    // 如果不是
    if (localStorage.getItem('isLogin')) {
      // 判断当前浏览器的本地存储里面是不是有已经登录的信息
      next() // 有的话，ok，去你想去的地址
    } else {
      // 没有的话，也就是没有登录
      next({ path: '/' }) // 去登录页
    }
  }
})

new Vue({
  router,
  store,
  data: function () {
    return {
      messageStatus: ''// 定义全局变量 实时故障是否开启通知
    }
  },
  render: h => h(App)
}).$mount('#app')
